// Primitives
export { Spinner, type SpinnerProps } from './lib/spinner';
export { Skeleton, type SkeletonProps } from './lib/skeleton';
export { EmptyState } from './lib/empty-state';
export { ThemeToggle } from './lib/theme-toggle';

// Shared components
export { Modal } from './lib/modal';
export { FavoriteIcon, type FavoriteIconProps } from './lib/favorite-icon';
export { FavoriteToggleButton, type FavoriteToggleButtonProps } from './lib/favorite-toggle-button';
export { ProductImage } from './lib/product-image';
export { ShareButton } from './lib/share-button';
export { ArticleTitleButton, type ArticleTitleButtonProps } from './lib/article-title-button';
export { ArticleNameBlock, type ArticleNameBlockProps } from './lib/article-name-block';
export { SelectionBar, type SelectionBarProps } from './lib/selection-bar';
export { Checkbox, type CheckboxProps } from './lib/checkbox';
export { SelectAllToggle, type SelectAllToggleProps } from './lib/select-all-toggle';
export {
  type AccentId,
  type AccentOption,
  ACCENT_OPTIONS,
  accentHex,
  accentBorderStyle,
  accentIconStyle,
} from './lib/template-accent';
export { SearchClearButton } from './lib/search-clear-button';

// Modals
export { PriceHistoryModal } from './lib/price-history-modal';
export { InquiryModal } from './lib/inquiry-modal';
export { BottomSheet } from './lib/bottom-sheet';
export {
  SortSheet,
  type SortDir,
  type SortFieldOption,
  type SortSheetProps,
} from './lib/sort-sheet';

// Navigation highlight state
export {
  NavHighlightProvider,
  useNavHighlight,
  type NavHighlightKey,
} from './lib/nav-highlight-provider';

// Search-term highlighting (Belegsuche)
export {
  SearchHighlightProvider,
  useSearchHighlight,
  useSearchMatches,
  HighlightText,
  MARK_CLASS,
  type SearchMatchKind,
  type SearchMatchToken,
} from './lib/search-highlight';

// Label colors (shared: Projekte & Favoriten)
export {
  type TagColorId,
  TAG_COLOR_OPTIONS,
  resolveLabelColor,
  labelColor,
} from './lib/tag-colors';

// Label management components (shared: Projekte & Favoriten)
export * from './lib/tag-color-swatches';
export * from './lib/tag-manage-content';
export * from './lib/tag-filter';
export * from './lib/tag-manager';
